import type { Observable } from '@spotar/runtime';
import type TrayChoice from '../tray-choice';

type TraySpawnChoiceOption = {
  value: string;
  label: string;
};

type TraySpawnChoiceData = {
  options?: TraySpawnChoiceOption[];
  default?: string;
  choiceRef: Observable<TrayChoice>;
};

let trayChoice: TrayChoice | null = null;

export function initTraySpawnChoiceImplementation(trayChoiceParam: TrayChoice) {
  trayChoice = trayChoiceParam;
}

export async function runTraySpawnChoiceImplementation(
  data: TraySpawnChoiceData,
  nodeId: string
) {
  const options = Array.isArray(data.options) ? data.options : [];
  const choiceOptions = options.map((option) => ({
    id: option.value,
    label: option.label,
  }));
  const defaultValue = data.default ?? '';
  const defaultSelectedIndex =
    defaultValue === ''
      ? -1
      : choiceOptions.findIndex((option) => option.id === defaultValue);

  trayChoice?.updateOptions(choiceOptions);
  trayChoice?.setSelectedIndex(defaultSelectedIndex);
  trayChoice?.show();
  if (!trayChoice) return;
  data.choiceRef.value = trayChoice;
}
